export const ROLES_TAG_TYPE = 'Roles' as const;
export const PERMISSIONS_TAG_TYPE = 'Permissions' as const;
export const SECURITY_PERMISSIONS_TAG_TYPE = 'SecurityPermissions' as const;
